import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Chart } from 'chart.js';
import { UnitsService } from 'src/app/core/services/units.service';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';
import { LineCharData } from 'src/app/modules/dashboard/utils/line_chart_data';

@Component({
  selector: 'unit-report-resume',
  templateUrl: './unit-report-resume.component.html',
  styleUrls: ['./unit-report-resume.component.scss'],
})
export class UnitReportResumeComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private resumeService: ResumeService,
    private unitsService: UnitsService
  ) {}

  ngOnInit() {
    this.resumeService.filterResumeReport.subscribe({
      next: (filters: any) => {
        for (let key in filters) {
          if (
            filters[key] == '' ||
            filters[key] == 'null' ||
            filters[key] == null
          ) {
            delete filters[`${key}`];
          }
        }
        this.getDataUnit(filters);
      },
    });
    this.getUnit();
  }
  data;
  dataSource;
  displayedColumns: string[] = [];

  setData(data: []) {
    this.data = data;
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
  }
  unitSelected;
  res;
  units;
  async getUnit() {
    await this.unitsService.getAll().subscribe((res) => {
      this.units = res;
    });
  }
  getDataUnit(filters = {}) {
    this.resumeService.unitReportResumen(filters).subscribe((res: any) => {
      this.res = res;
      this.displayedColumns = res.labelTable;
      this.setData(res.table);
      this.byUnitReportResume(res.casesByUnit);
    });
  }
  bar: Chart;
  byUnitReportResume(data) {
    if (this.bar) {
      this.bar.destroy();
    }
    var canvas = document.getElementById(
      'ByUnitReportResume'
    ) as HTMLCanvasElement;
    var parent = document.getElementById('contentByUnitReportResume');

    // canvas.width = parent.offsetWidth;
    this.bar = new Chart('ByUnitReportResume', {
      type: 'bar',
      data: {
        labels: data.labels,

        datasets: [
          {
            data: data.countCases,
            backgroundColor: [
              '#005dd0',
              '#2e8cef',
              '#30c5ff',
              '#f6a506',
              '#f58500',
              '#ff5733',
              '#ff0055',
            ],
          },
        ],
      },
      options: {
        // indexAxis: 'y',
        elements: {
          // bar: {
          //   borderWidth: 2,
          // }
        },
        responsive: true,

        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var value =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value.toString();
            },
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });
  }
}
